import styled from 'styled-components'

import { font } from '~/styles/utils'

export const ProductLine = styled.div`
  padding: 0 0 12px 0;
  ${font('base')};
  font-size: 16px;
  line-height: 17px;
  display: flex;
  justify-content: space-between;
`
